import request from '@/utils/request';
import { IOrderCheckParams, IOrderCheckSettingParams, IOrderCheckFlowParams } from '@/types/orderCheck';

export const getOrderCheckSettingList = (params: IOrderCheckParams) => request({
  url: 'OrderCheck/flowList',
  method: 'GET',
  params
});

export const setOrderCheckName = (data: IOrderCheckSettingParams) => request({
  url: 'OrderCheck/editFlow',
  method: 'POST',
  data
});

export const setOrderCheckFlow = (data: IOrderCheckFlowParams) => request({
  url: 'OrderCheck/saveAllFlow',
  method: 'POST',
  data
});

export const getOrderCheckList = (params: IOrderCheckParams) => request({
  url: 'Order/orderCheckList',
  method: 'GET',
  params
});
// 获取标签
export const getTags = (params: any) =>
  request({
    url: 'Other/tags',
    method: 'get',
    params
  });
// 获取服务方
export const getServerList = (params: any) =>
  request({
    url: 'Servicer/servicer',
    method: 'get',
    params
  });
// 添加规则
export const addFilter = (data: any) =>
  request({
    url: 'OrderCheck/addFilter',
    method: 'post',
    data
  });
  // 获取规则列表
export const getFilterList = (params: any) =>
  request({
    url: 'OrderCheck/filterList',
    method: 'get',
    params
  });
// 删除规则列表
export const delFilter = (data: any) =>
  request({
    url: 'OrderCheck/deleteFilter',
    method: 'post',
    data
  });
  // 编辑规则

export const editFilter = (data: any) =>
  request({
    url: 'OrderCheck/editFilter',
    method: 'post',
    data
  });
  // 开启审核规则
export const openFilter = (data: any) =>
  request({
    url: 'OrderCheck/cutFilterSwitch',
    method: 'post',
    data
  });

// 审核通过
export const checkOrderPass = (data:any) => request({
  url: 'Order/orderCheckPass',
  method: 'put',
  data
});

// 审核驳回
export const orderCheckClose = (data:any) => request({
  url: 'Order/orderCheckClose',
  method: 'put',
  data
});

// 编辑规则人员
export const editFlowUser = (data:any) => request({
  url: 'OrderCheck/editFlowUser',
  method: 'PUT',
  data
});

export const getOrderCheckDetail = (params: any) =>
  request({
    url: 'Order/orderCheckDetail',
    method: 'get',
    params
  });
